<div class="rounded signature">
  <signature-pad
    *ngIf="!src"
    [options]="options"
    (onEndEvent)="onEnd()"
    (onBeginEvent)="onStart()"
    #signaturePad
  ></signature-pad>
  <img *ngIf="src" [src]="src" [height]="height" [width]="width" />
  <hr class="hr signature-line sm-m-auto" />
</div>
